import moment from 'moment-jalaali';
import 'moment/locale/fa';

export default function useConvertToJalaliDate() {
  /**
   * return jalali date
   * @param value // like: 2023-1-1
   * @returns // like: 1401-10-11 , امروز,دیروز
   */
  function toJalali(
    value: string,
    format = 'dddd jDD jMMMM jYYYY', // افزودن روز هفته
    currentYearFormat = 'dddd jDD jMMMM', // افزودن روز هفته برای سال جاری
    todayFormat = 'dddd jDD jMMMM',
    yesterdayFormat = 'dddd jDD jMMMM'
  ) {
    moment.updateLocale('fa', {
      jMonths: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
      weekdays: ['یک‌شنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'], // تعریف نام روزهای هفته
    });
    moment.locale('fa');

    const formattedValue = value?.replace(/\//g, '-');
    const m = moment(formattedValue);

    const now = moment();
    const isToday = m.isSame(now, 'day') && m.isSame(now, 'month') && m.isSame(now, 'year');
    const yesterday = now.clone().subtract(1, 'day');
    const isYesterday = yesterday.isSame(m, 'day') && yesterday.isSame(m, 'month') && yesterday.isSame(m, 'year');
    const isCurrentYear = m.year() === now.year();

    if (isToday) {
      return todayFormat ? 'تاریخ امروز ' + m.format(todayFormat) : ' امروز';
    } else if (isYesterday) {
      return yesterdayFormat ? 'تاریخ دیروز' + m.format(yesterdayFormat) : 'تاریخ دیروز';
    } else if (isCurrentYear) {
      return m.format(currentYearFormat);
    } else {
      return m.format(format);
    }
  }

  function getJalaliYear(value: string) {
    return moment(value).jYear();
  }

  return {
    getJalaliYear,
    toJalali,
  };
}
